var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 55,
    fill: "none",
    viewBox: "0 0 52 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M47.477 41.516c-5.772-4.296-11.31-7.112-12.561-7.729a.469.469 0 0 1-.268-.426v-5.115c.781-1.335 1.284-2.738 1.474-4.016.57-.045 1.306-.842 2.11-3.691 1.094-3.893-.067-4.465-1.05-4.375.19-.539.335-1.066.425-1.604 1.675-10.085-3.272-10.433-3.272-10.433s-.815-1.581-2.981-2.782c-1.44-.863-3.462-1.525-6.108-1.3a9.014 9.014 0 0 0-2.434.47c-.972.337-1.865.82-2.68 1.38a14.07 14.07 0 0 0-2.758 2.288c-1.306 1.347-2.479 3.085-2.981 5.25-.425 1.616-.324 3.31.022 5.127.1.527.235 1.066.425 1.604-.983-.09-2.156.482-1.05 4.375.804 2.85 1.552 3.646 2.11 3.69.201 1.29.704 2.715 1.474 4.061v5.07c0 .18-.1.349-.268.427-1.25.617-6.789 3.421-12.561 7.729C1.675 43.659 0 47.069 0 50.658v1.38a2.947 2.947 0 0 0 2.937 2.95H49.063a2.947 2.947 0 0 0 2.936-2.95v-1.38c.034-3.6-1.64-7-4.522-9.142z",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/default_user.507810e26af9b2795584f8caab6d12e3.svg";
export { ForwardRef as ReactComponent };